module.exports = __webpack_public_path__ + "static/media/logo.406c5451.png";